/** @class {Action} */
import Action from '../flux/Action';

/** @type {Action} */
export default new Action({
  LOAD:         0,
  LOAD_SUCCESS: 1,
  LOAD_ERROR:   2,

  RELOAD_AVAILABILITY: 3,
  REFRESH_AVAILABILITY: 4,

  // SELECTION ACTIONS
  SEAT_TOGGLE:     10,
  SEAT_REMOVE:     11,
  SEAT_REMOVE_ALL: 12,
  SECTION_TOGGLE:  13,
  SECTION_RESET:   14,

  // HOVER TOOLTIP ACTIONS
  HOVER_ENTER: 20,
  HOVER_LEAVE: 21,

  PRICE_RANGE_TOGGLE: 40,

  // UPDATE SINGLE SEAT AVAILABILITY
  UPDATE_SINGLE_SEAT: 47
});



// WEBPACK FOOTER //
// ./frontend/react/sim/core/actions/map.js